import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';
import ButtonV3 from '@zola/zola-ui/src/components/ButtonV3/ButtonV3';

import cx from 'classnames';

import SmallVendorCard from '~/components/common/cards/SmallVendorCard/SmallVendorCard';
import { getStorefrontDetails } from '~/libs/client/api/storefronts';
import { useInquiryModal } from '~/pages/couples/inquiry-flow/showInquiryModal';
import { useAppDispatch } from '~/reducers';
import { StandardLogFn } from '~/util/logger';
import getCanonicalUrl from '~/util/storefrontUrl';
import { TrackingProductLocation } from '~/util/trackingHelper';

import { getSmallVendorCardStorefront } from '../utils/helpers';

import styles from './smallVendorCardList.module.less';

const SmallVendorCardList = ({
  cardList,
  className,
  trackingProductLocation,
  onSuccess,
}: {
  cardList: StorefrontCardView[];
  className?: string;
  trackingProductLocation: TrackingProductLocation;
  onSuccess?: () => void;
}) => {
  const dispatch = useAppDispatch();
  const { showInquiryModal } = useInquiryModal();

  const triggerInquiryModal = (slug: string | null) => {
    if (slug) {
      getStorefrontDetails(slug)
        .then((storefront) => {
          showInquiryModal({
            dispatch,
            storefront,
            trackingLocation: trackingProductLocation,
            onSuccess,
          });
        })
        .catch(StandardLogFn);
    }
  };

  return (
    <div className={cx(styles.smallVendorCardList, className)}>
      {cardList.map((vendor: StorefrontCardView) => {
        const storefront = getSmallVendorCardStorefront(vendor);
        const to =
          storefront &&
          storefront.vendorCard.storefrontSlug &&
          storefront.vendorCard.taxonomyNodeKey
            ? getCanonicalUrl(
                storefront.vendorCard.taxonomyNodeKey,
                storefront.vendorCard.storefrontSlug
              )
            : null;
        return storefront ? (
          <div className={styles.smallVendorCardWrapper} key={`favorites-${vendor.storefrontUuid}`}>
            <SmallVendorCard
              v2
              storefront={storefront}
              internalLink={to as string}
              trackClick={false}
            />
            <ButtonV3
              size="large"
              variant="secondary"
              onClick={() => triggerInquiryModal(storefront.vendorCard.storefrontSlug)}
            >
              Get a quote
            </ButtonV3>
          </div>
        ) : (
          <></>
        );
      })}
    </div>
  );
};

export default SmallVendorCardList;
